import { render } from "./PagoPlanTratamiento.vue?vue&type=template&id=2bede0f0&scoped=true"
import script from "./PagoPlanTratamiento.vue?vue&type=script&lang=js"
export * from "./PagoPlanTratamiento.vue?vue&type=script&lang=js"

import "./PagoPlanTratamiento.vue?vue&type=style&index=0&id=2bede0f0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bede0f0"]])

export default __exports__